import React from 'react'
import usePHPBKApi from '../../../custom-api/hooks/use-phpkb-api'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import ChevronRight from '../../../components/icons/arrows/ChevronRight'
import {Link, useLocation} from 'react-router-dom'
import PropTypes from 'prop-types'
import routingObject from '../../../utils/static-routes'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const FaqArticles = ({searchQuery, setFaqArticlesHits}) => {
    const styles = useMultiStyleConfig('Faq', {})
    const {articlesListStyles} = styles || {}
    /******FAQ SEARCH START*******/
    const {usePHPBKFreeTextSearch} = usePHPBKApi()
    const location = useLocation()
    const {locale} = useMultiSite()

    const {data, isLoading} = usePHPBKFreeTextSearch(
        {
            q: searchQuery,
        },
        {
            enabled: Boolean(searchQuery) && location.search.endsWith('=faq'),
        },
    )
    /******FAQ SEARCH END*******/
    let articles = []
    if (!isLoading && data) {
        articles = data?.hits?.hits
        setFaqArticlesHits(articles.length)
    }

    return (
        <Box>
            <>
                {articles.map((article) => (
                    <Flex
                        {...articlesListStyles?.articleWrapper}
                        key={article?._source?.article_id}
                    >
                        <Flex {...articlesListStyles?.articleInnerContainer}>
                            <ChevronRight {...articlesListStyles?.chevronIcon} />
                            <Link
                                to={`${locale?.alias}${routingObject.FAQ_PATH}/${article?._source?.category_name}/a/${article?._source?.article_id}`}
                            >
                                <Text {...articlesListStyles?.articleLink}>
                                    {article?._source?.article_title}
                                </Text>
                            </Link>
                        </Flex>
                    </Flex>
                ))}
            </>
        </Box>
    )
}

FaqArticles.propTypes = {
    searchQuery: PropTypes.string,
    setFaqArticlesHits: PropTypes.func,
}

export default FaqArticles
